import { Component, OnInit } from '@angular/core';
import { UserService, TrabajosService, TrabajosInvitadosService, CategoriaTrabajoService, MailService, CongresosService, SidebarService, TranslationService, CategoriaInscripcionService, ActividadesService } from '../../services/services.index';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { URL_SERVICES } from '../../config/config';
import { Congreso } from '../../models/congreso.model';

declare let paypal: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styles: []
})
export class DashboardComponent implements OnInit {

  archivoSubir: any;
  trabajo: any;
  trabajoInvitado: any;
  hideModalTrabajo: string = 'hide-modal';
  hideModalTrabajoInvitado: string = 'hide-modal';
  hideModalDetalleCostos: string = 'hide-modal';
  arbolDeCategorias: any;

  forma: FormGroup;

  loading: boolean = false;
  congreso: Congreso;
  certificadosHabilitados: boolean = false;

  total: number;
  categoriaInscripcion: any;
  actividades: any[];

  // Paypal
  addScript: boolean = false;
  paypalConfig: any = {
    env: 'production',
    client: {
      sandbox: 'AbbzNSjyygrEv1lzvfmmGhOkLJNMgwTPhqbo7dBJZv0lgR4zEHtu2doHrNMUZ09qbdK5RBn-SXmFGInR',
      production: 'AcjZqgd8WSZD-K4njxHUDsKo9P5DqBNfA_7_VXpouzppPAvQf7GJlmHvjQVNdEFZqGertwqfaRk9YA1g'
    },
    commit: true,
    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [
            {amount: { total: this.total, currency: 'USD' } }
          ]
        }
      });
    },
    onAuthorize: (data, actions) => {
      return actions.payment.execute().then((payment) => {
        this.guardarPagoPaypal(payment);
      });
    }
  };
  paypalButtonLoading: boolean = true;

  constructor( public _userService: UserService,
              public _trabajosService: TrabajosService,
              public router: Router,
              public _trabajosInvitadosService: TrabajosInvitadosService,
              public _categoriaTrabajoService: CategoriaTrabajoService,
              public _mailService: MailService,
              public _congresosService: CongresosService,
              public _sidebarService: SidebarService,
              public _translationService: TranslationService,
              public _categoriaInscripcionService: CategoriaInscripcionService,
              public _actividadesService: ActividadesService ) {
    this._userService.actualizarUsuario();
    // Si es administrador redirecciono al escritorio del admin.
    if (this._userService.user.role === 'ADMIN_ROLE') {
      this.router.navigate(['/escritorio-admin']);
    }

    this.forma = new FormGroup({
      razonSocial: new FormControl('', [Validators.required, Validators.minLength(3)]),
      direccion: new FormControl('', [Validators.required, Validators.minLength(3)]),
      cuit: new FormControl('', [Validators.required, Validators.minLength(3)]),
      condicionIva: new FormControl('', [Validators.required, Validators.minLength(3)])
    });
  }

  ngOnInit() {
    this.cargarCongreso();
  }

  cargarCongreso() {
    this.loading = true;
    this._congresosService.getCongresoActivo().subscribe(resp => {
      if (resp.length === 1) {
        this.congreso = resp[0];
        let today: number = new Date().getTime();
        if (today > this.congreso.fechaFinCongreso) {
          this.certificadosHabilitados = true;
        } else {
          this.certificadosHabilitados = false;
        }
        // Si el usuario no pago actualizo precios
        if (!this._userService.user.pago) {
          this.actualizarPrecios();
        } else {
          this.loading = false;
        }
      }
    });
  }

  actualizarPrecios() {
    this.loading = true;
    let promises: any[] = [];
    promises.push(
      // tslint:disable-next-line:no-shadowed-variable
      new Promise((resolve, reject) => {
        this._categoriaInscripcionService.getPrecioActualizado(this.congreso._id, this._userService.user.categoriaInscripcion.categoriaInscripcion)
            .subscribe(resp => {
              this.categoriaInscripcion = resp;
              if (this._userService.user.invitado && !this._userService.user.comunicacionesLibres) {
                this.categoriaInscripcion.precio = 0;
                this.categoriaInscripcion.precio_usd = 0;
              }
              resolve();
            });
      })
    );
    promises.push(
      // tslint:disable-next-line:no-shadowed-variable
      new Promise((resolve, reject) => {
        this._actividadesService.getPrecioActualizado(this.congreso._id, this._userService.user.actividades)
            .subscribe(resp => {
              this.actividades = resp;
              resolve();
            });
      })
    );
    Promise.all(promises).then(resp => {
      if (this._userService.user.moneda === 'ARG') {
        this.total = this.categoriaInscripcion.precio;
      } else {
        this.total = this.categoriaInscripcion.precio_usd;
        if (!this.addScript && !this._userService.user.pago) {
          this.addPaypalScript().then(() => {
            paypal.Button.render(this.paypalConfig, '#paypal-checkout-button');
            this.paypalButtonLoading = false;
          });
        }
      }
      this.total = this.total + this.sumaPrecioActividades();
      this.loading = false;
    });
  }

  sumaPrecioActividades() {
    let total: number = 0;
    for (let actividad of this.actividades) {
      if (this._userService.user.moneda === 'ARG') {
        total = total + actividad.precio;
      } else {
        total = total + actividad.precio_usd;
      }
    }
    return total;
  }

  // ngAfterViewChecked(): void {
  //   if (!this.addScript && this._userService.user.paisResidencia !== 'AR' && !this._userService.user.pago) {
  //     this.addPaypalScript().then(() => {
  //       paypal.Button.render(this.paypalConfig, '#paypal-checkout-button');
  //       this.paypalButtonLoading = false;
  //     });
  //   }
  // }

  addPaypalScript() {
    this.addScript = true;
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise((resolve, reject) => {
      let scripttagElement = document.createElement('script');
      scripttagElement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    });
  }

  guardarPagoPaypal(payment: any) {
    this._userService.registrarPagoPaypal(this._userService.user, payment, this.categoriaInscripcion, this.actividades, this.total).subscribe((respPaypal: any) => {
      this._userService.user.paypalIdPago = respPaypal.user.paypalIdPago;
      this._userService.user.pago = true;
      this._userService.user.aprobado = true;
      this._userService.actualizarUsuario();

      let lang: string = this._translationService.lang;
      let tituloSwal: string;
      let mensajeSwal: string;
      if (lang === 'es') {
        tituloSwal = 'Pago Registrado';
        mensajeSwal = 'El pago fué registrado correctamente.';
      } else {
        tituloSwal = 'Registered Payment';
        mensajeSwal = 'The payment was registered correctly.';
      }

      swal(tituloSwal, mensajeSwal, 'success');
      // Envio de email notificacion para administradores
      this._congresosService.getCongreso(this._userService.user.congreso).subscribe((respCongreso: any) => {
        let congreso: any = respCongreso.congreso;
        this._mailService.mailPagoRecibidoAdmin(congreso.titulo_es,
                                                this._userService.user.name,
                                                this._userService.user.apellido,
                                                congreso.contactosPago,
                                                congreso.sociedadOrganizadora,
                                                this._userService.user.email,
                                                this._userService.user.sociedad,
                                                this._userService.user.facturaRazonSocial,
                                                this._userService.user.facturaDireccion,
                                                this._userService.user.facturaCuit,
                                                this._userService.user.facturaCondicionIva,
                                                undefined,
                                                this._userService.user.total,
                                                'paypal',
                                                this._userService.user.paypalIdPago).subscribe(ok => {});
      });
    });
  }

  seleccionArchivo(archivo: File) {
    if ( !archivo ) {
      this.archivoSubir = undefined;
      return;
    }

    // Si el archivo no es una imagen
    if (archivo.type.indexOf('image') < 0 &&
        archivo.type.indexOf('pdf') < 0 &&
        archivo.type.indexOf('application/vnd.openxmlformats-officedocument.wordprocessingml.document') < 0 ) {

          let lang: string = this._translationService.lang;
          let tituloSwal: string;
          let mensajeSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Tipo de archivo inválido';
            mensajeSwal = 'Solo pueden seleccionarse archivos tipo imagen, PDF y Word.';
          } else {
            tituloSwal = 'Invalid file type';
            mensajeSwal = 'Only image, PDF and Word files can be selected.';
          }
          swal(tituloSwal, mensajeSwal, 'error');
      this.archivoSubir = undefined;
      return;
    }

    // Si el archivo es imagen, obtengo la url temporal para mostrarlo en el perfil antes de subirlo
    this.archivoSubir = archivo;
  }

  subirArchivo() {
    let datosFacturacion: any = {};
    datosFacturacion.facturaRazonSocial = this.forma.controls['razonSocial'].value;
    datosFacturacion.facturaDireccion = this.forma.controls['direccion'].value;
    datosFacturacion.facturaCuit = this.forma.controls['cuit'].value;
    datosFacturacion.facturaCondicionIva = this.forma.controls['condicionIva'].value;
    datosFacturacion.categoriaInscripcion = this.categoriaInscripcion;
    datosFacturacion.actividades = this.actividades;
    datosFacturacion.total = this.total;
    this._userService.subirArchivo(this.archivoSubir, this._userService.user._id, datosFacturacion)
    .then((resp: any) => {
      // Actualizacion de datos de usuario
      this._userService.actualizarDatosFacturacion(this._userService.user, datosFacturacion).subscribe(respDatosFact => {
        this._userService.user.comprobante = resp.usuario.comprobante;
        this._userService.user.pago = resp.usuario.pago;
        this._userService.user.facturaRazonSocial = datosFacturacion.facturaRazonSocial;
        this._userService.user.facturaDireccion = datosFacturacion.facturaDireccion;
        this._userService.user.facturaCuit = datosFacturacion.facturaCuit;
        this._userService.user.facturaCondicionIva = datosFacturacion.facturaCondicionIva;
        this._userService.user.categoriaInscripcion = resp.usuario.categoriaInscripcion;
        this._userService.user.actividades = resp.usuario.actividades;

        let lang: string = this._translationService.lang;
          let tituloSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Comprobante Actualizado';
          } else {
            tituloSwal = 'Proof Updated';
          }
        swal(tituloSwal, this._userService.user.name + ' ' + this._userService.user.apellido, 'success');
        this._userService.actualizarUsuario();
        // Envio de email notificacion para administradores
        this._congresosService.getCongreso(this._userService.user.congreso).subscribe((respCongreso: any) => {
          let congreso: any = respCongreso.congreso;
          let urlComprobante: string = URL_SERVICES + '/comprobante/' + this._userService.user.comprobante;
          this._mailService.mailPagoRecibidoAdmin(congreso.titulo_es,
                                                  this._userService.user.name,
                                                  this._userService.user.apellido,
                                                  congreso.contactosPago,
                                                  congreso.sociedadOrganizadora,
                                                  this._userService.user.email,
                                                  this._userService.user.sociedad,
                                                  this._userService.user.facturaRazonSocial,
                                                  this._userService.user.facturaDireccion,
                                                  this._userService.user.facturaCuit,
                                                  this._userService.user.facturaCondicionIva,
                                                  urlComprobante,
                                                  this._userService.user.total,
                                                  'transferencia').subscribe(ok => {});
          this._sidebarService.loadMenu();
        });
      });

    })
    .catch(resp => {
      console.log(resp);
    });
  }

  verTrabajo() {
    this._trabajosService.getTrabajo(this._userService.user).subscribe((trabajo: any) => {
      this.trabajo = trabajo;
      this._categoriaTrabajoService.getArbolCategorias(this.trabajo.categoriasTrabajo).subscribe((resp: any) => {
        this.arbolDeCategorias = resp.categoriasTrabajo.reverse();
      });
      this.showModalRevisionTrabajo();
    });
  }

  hideModalRevisionTrabajo() {
    this.hideModalTrabajo = 'hide-modal';
  }

  hideModalDetalleCostosMethod() {
    this.hideModalDetalleCostos = 'hide-modal';
  }

  showModalDetalleCostos() {
    this.hideModalDetalleCostos = '';
  }

  showModalRevisionTrabajo() {
    this.hideModalTrabajo = '';
  }

  hideModalRevisionTrabajoInvitado() {
    this.hideModalTrabajoInvitado = 'hide-modal';
  }

  showModalRevisionTrabajoInvitado() {
    this.hideModalTrabajoInvitado = '';
  }

  inicialesNombres(nombres: string) {
    let iniciales: string = '';
    let arrayNombres: any[] = nombres.split(' ');
    for (let nombre of arrayNombres) {
      iniciales = iniciales + nombre.substr(0, 1) + '.';
    }
    return iniciales.toUpperCase();
  }

  superindiceLugares(lugaresTrabajo: any) {
    let superindice: string = '';
    for (let lugar of lugaresTrabajo) {
      if (superindice === '') {
        superindice = superindice + lugar;
      } else {
        superindice = superindice + ',' + lugar;
      }
    }
    return superindice;
  }

  verTrabajoInvitado() {
    this._trabajosInvitadosService.getTrabajo(this._userService.user).subscribe((trabajo: any) => {
      this.trabajoInvitado = trabajo;
      this.showModalRevisionTrabajoInvitado();
    });
  }

  getNombreByLang (objeto: any) {
    if (this._translationService.lang === 'es') {
      objeto.nombre_lang = objeto.nombre_es;
    } else if (this._translationService.lang === 'en') {
      objeto.nombre_lang = objeto.nombre_en;
    }
    return objeto.nombre_lang;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.component.ts